import {
  FC,
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction
} from "react";
import * as authHelper from './AuthHelpers'
import {WithChildren} from '../../../../_metronic/helpers'
import { IAuthInfoModel, IAuthUserToken } from "../../../../constants";

type AuthContextProps = {
  auth: IAuthUserToken | undefined
  saveAuth: (auth: IAuthUserToken | undefined) => void
  currentUser: IAuthInfoModel | undefined
  setCurrentUser: Dispatch<SetStateAction<IAuthInfoModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<IAuthUserToken | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<IAuthInfoModel | undefined>()
  const saveAuth = (auth: IAuthUserToken | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

// @TODO Auth changes
const AuthInit: FC<WithChildren> = ({children}) => {
  return  <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
